import * as React from "react";
import FormikAutocompleteField from "../../formik/FormikAutocomplete";
import PropTypes from "prop-types";
import { HttpClientConfig } from "../../../utils/HttpClient";

export const ProductTypeAutocomplete = (props) => {
  const lookupUrl = `${HttpClientConfig.baseURL}/ProductType/Lookup`;
  const lookupByIdUrl = `${HttpClientConfig.baseURL}/ProductType/LookupById`;

  const handleAddClick = (e) => {
    console.log(e);
  }

  return (
    <FormikAutocompleteField {...props} lookupUrl={lookupUrl} lookupByIdUrl={lookupByIdUrl} onAddButtonClick={handleAddClick} />
  );
};

ProductTypeAutocomplete.propTypes = {
  fieldName: PropTypes.string,
  label: PropTypes.string,
  formik: PropTypes.any
}

export default ProductTypeAutocomplete;
